import React from 'react';
import { ActivityIcon, UsersIcon, MoveDownIcon } from 'lucide-react';
const metrics = [{
  icon: ActivityIcon,
  value: '28.8%',
  label: 'of U.S. yoga practitioners are in class to treat or manage physical pain (CDC / NCHS, 2022)'
}, {
  icon: UsersIcon,
  value: '100,000+',
  label: 'Registered Yoga Teachers worldwide (Yoga Alliance)'
}, {
  icon: MoveDownIcon,
  value: '2 in 3',
  label: 'musculoskeletal yoga injuries affect the lower body (systematic review)'
}];
export function ProofBar() {
  return <section aria-label="The market this system was built for" className="w-full bg-forest text-white" data-id="element-261" data-mp="3he4aybr6dme">
      <div className="mx-auto max-w-content px-5 py-8 sm:px-8 sm:py-12 lg:py-16" data-id="element-262" data-mp="3pqp6p4m8tdwn">
        <ul className="divide-y divide-white/10 lg:grid lg:grid-cols-3 lg:gap-8 lg:divide-y-0" data-id="element-263" data-mp="3psrvxmfkn30b">
          {metrics.map(({
          icon: Icon,
          value,
          label
        }) => <li key={value} className="flex items-center gap-4 py-4 lg:flex-col lg:gap-2 lg:py-0 lg:text-center" data-id="element-264" data-mp="1ny9cgc2lpbms">
              <Icon className="h-6 w-6 shrink-0 text-sage-soft lg:h-7 lg:w-7" strokeWidth={1.5} aria-hidden="true" data-id="element-265" data-mp="2nfvevytfhfmo" />
              <div className="lg:contents" data-id="element-266" data-mp="326ukd0yyvo21">
                <p className="font-serif text-2xl font-semibold leading-tight text-white sm:text-3xl" data-id="element-267" data-mp="2x5f03b4m5lkp">
                  {value}
                </p>
                <p className="mt-0.5 font-sans text-[14px] leading-snug text-white/70 lg:mx-auto lg:mt-1 lg:max-w-[18rem] lg:text-[13px]" data-id="element-268" data-mp="29i6v6ub3kej7">
                  {label}
                </p>
              </div>
            </li>)}
        </ul>

        <div className="mx-auto mt-10 max-w-2xl border-t border-white/10 pt-8 text-center lg:mt-12" data-id="element-269" data-mp="2eenu8jju4db2">
          <p className="font-sans text-[12px] font-semibold uppercase tracking-[0.14em] text-brass" data-id="element-270" data-mp="3tvegfrr09odu">
            And 90 seconds — to find any condition, any variation, any script.
          </p>
          <p className="mt-5 font-sans text-[15px] leading-[1.6] text-white/75" data-id="element-271" data-mp="2mjye40r4ikgy">
            Roughly three in ten people on your mats are there because something hurts. That's not
            the exception. That's your class.
          </p>
        </div>
      </div>
    </section>;
}